import editorPlugins from './editor';
import renderPlugins from './render';

export { editorPlugins, renderPlugins };

export default {
  default: [...editorPlugins, ...renderPlugins]
};